<template>
	<div class="cog-picker" :class="{'cog-picker__native-icon-container': $slots.icon}">
		<input v-if="placeholder && showPlaceholder" aria-hidden="true" tabindex="-1" type="text" :placeholder="placeholder" class="cog-picker__native-placeholder el-input__inner">
		<slot />
		<span v-if="$slots.icon" class="el-input__suffix">
			<slot name="icon" />
		</span>
	</div>
</template>

<script>
	export default {
		name: 'CPickerNative',
		props: {
			placeholder: {
				type: String,
				default: null
			},
			showPlaceholder: {
				type: Boolean,
				default: false
			}
		}
	};
</script>

<style lang="scss">
#{$specificity-base} {

	.cog-picker__native-placeholder {
		// The faux placeholder input should allow the select's border to peak around it
		position: absolute;
		bottom: var(--input__border-width-bottom, var(--input__border-width));
		left: var(--input__border-width-left, var(--input__border-width));
		top: var(--input__border-width-top, var(--input__border-width));
		background: transparent;
		pointer-events: none;

		@include at-root(1) {

			.cog-picker__native-placeholder {
				width: calc(100% - (var(--input__border-width-left, var(--input__border-width)) + var(--input__border-width-right, var(--input__border-width))));
				border: 0;
			}
		}
	}

	.cog-picker__native-icon-container {
		position: relative;

		select {
			display: block;
			white-space: nowrap;
		}

		.el-input__suffix {
			pointer-events: none;
		}

		[type='date'],
		[type='time'] {
			// Date inputs are too tall without this intervention.
			// https://stackoverflow.com/questions/52703412/how-to-fix-inconsistent-height-of-html5-input-boxes
			min-height: calc((var(--input__padding-v) * 2) + (var(--line-height) * 1em));

			// Doesn't work in iOS. See hideDatePickerIcon mixin.
			padding-right: 0 !important;
		}
	}

	.cog-cognito--styled {

		.cog-picker__native-icon-container {

			select,
			input {
				line-height: calc(var(--line-height) - .1);
				appearance: none;
			}

			input::-webkit-calendar-picker-indicator {
				opacity: 0;
			}

			// For reasons beyond me, the date and time picker indicators require different CSS to accomplish the same thing.
			// Namely, cause the date or time value to not overlap the icon but also not have an unnecessary gap between the value and icon.
			// On iOS we hide the picker because this approach doesn't work. See hideDatePickerIcon mixin.
			[type='date']::-webkit-calendar-picker-indicator {
				width: 0;
				margin-right: -5px;
				transform: scaleY(1.8) scaleX(8.5);
			}

			[type='time']::-webkit-calendar-picker-indicator {
				width: 10px;
				transform: scaleY(1.8) scaleX(1.8);
			}
		}

		.cog-select option {
			color: var(--input__color);
		}

		.el-input__inner.is-null,
		.cog-select option[value=''] {
			color: var(--placeholder__color);
		}

		// Adjust the datalist input appearance for mobile
		.cog-picker .el-input__inner[list] {
			padding-right: 0;

			&::-webkit-calendar-picker-indicator,
			&::-webkit-list-button {
				width: 0;
				opacity: 0;
			}
		}
	}
}
</style>